<div class="card card-custom gutter-b" style="margin-bottom: 20px;">
  <div class="card-body">
    <div class="row">
      <div class="col-lg-9">
        <div class="form form-label-right">
          <form style="padding-bottom: 0px !important;" [formGroup]="searchGroup" class="form-group row"
            (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-lg-4">
                <h5>{{'COMMON.SEARCH' | translate}} {{'APPOINTMENTS.COMMON.BY_FROMDATE'| translate}}</h5>
                <div class="input-group">
                  <input readonly class="form-control" placeholder="yyyy-mm-dd" name="dp" formControlName="Fromdate"
                    ngbDatepicker #Fromdate="ngbDatepicker" />
                  <button class="btn btn-outline-secondary bi bi-calendar3" (click)="Fromdate.toggle()" type="button"><i
                      class="icofont-calendar"></i></button>
                </div>

              </div>
              <div class="col-lg-4">
                <h5>{{'COMMON.SEARCH' | translate}} {{'APPOINTMENTS.COMMON.BY_TODATE'| translate}}</h5>
                <div class="input-group">
                  <input readonly class="form-control" placeholder="yyyy-mm-dd" name="dp" formControlName="Enddate"
                    ngbDatepicker #Enddate="ngbDatepicker" />
                  <button class="btn btn-outline-secondary bi bi-calendar3" (click)="Enddate.toggle()" type="button"><i
                      class="icofont-calendar"></i></button>
                </div>

              </div>
              <div class="col-lg-4" style="margin-top: 11px;">
                <div class="form-group form-group-inline">
                  <button class="btn btn-primary" style="margin: 5px;font-weight: bold;" color="primary"
                    type="submit">{{'COMMON.SEARCH' | translate}}</button>
                  <button class="btn btn-danger" style="font-weight: bold;" color="warn"
                    (click)="Clear()">{{'COMMON.CLEAR' | translate}}</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-3">
        <button class="custom-btn btn-12" routerLink="/portal/appointments/specialties">
          <span style="width: 190px !important;">{{'APPOINTMENTS.GRID.CLICK' | translate}}!</span><span
            style="width: 190px !important;">{{'APPOINTMENTS.GRID.NEWAPPOINTMENT' | translate}}</span>
        </button>
      </div>
    </div>

  </div>
</div>
<div class="card card-custom gutter-b">
  <ngx-spinner></ngx-spinner>
  <ng-container *ngIf="isLoading$ | async">
    <div class="progress progress-modal">
      <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
        style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </ng-container>
  <div class="card-header">
    <div class="card-title">
      <h4 class="card-label">{{'COMMON.SEARCHRESULTS' | translate}}</h4>
    </div>
  </div>
  <div class="card-body">
    <!-- begin:Table -->
    <div class="table-responsive angular-bootstrap-table">
      <table class="table table-bordered text-center">
        <thead style="color: #205d89">
          <th>
            {{'APPOINTMENTS.GRID.APPOINTMENTDATE' | translate}}
          </th>
          <th>
            {{'APPOINTMENTS.GRID.SPECIALTY' | translate}}
          </th>
          <th>
            {{'APPOINTMENTS.GRID.DOCTORNAME' | translate}}
          </th>
          <th>
            {{'APPOINTMENTS.GRID.STATUS' | translate}}
          </th>
          <th>
            {{'APPOINTMENTS.GRID.IsPayed' | translate}}
          </th>
          <th>{{'COMMON.ACTIONS' | translate}}</th>
        </thead>
        <tbody>
          <tr *ngFor="let Appointment of AppointmentService.items$ | async">
            <td style="width: 177px;">{{ Appointment.fromTime | date : 'dd/MM/yyyy h:mm a' }}</td>
            <td>{{ language == 'en'? Appointment.department_Name : Appointment.department_Name_Arabic}}</td>
            <td style="width: 210px;">{{ language == 'en'? Appointment.appoinmentDoctorName : Appointment.appoinmentDoctorNameAR}}</td>
            <td >
              <span class="badge" [class.bg-secondary]="Appointment.appoinmentStatus == null "
                [class.bg-success]="Appointment.appoinmentStatus == 'CONFIRMED' " [class.bg-danger]="Appointment.appoinmentStatus == 'CANCELED'">
                <ng-container *ngIf="Appointment.appoinmentStatus == null">
                </ng-container>
                <ng-container *ngIf="Appointment.appoinmentStatus == 'CONFIRMED'">{{ language == 'en'? 'Confirmed' : 'تم تأكيدها'}}
                </ng-container>
                <ng-container *ngIf="Appointment.appoinmentStatus == 'CANCELED'">{{ language == 'en'? 'Canceled' : 'تم الغائها'}}
                </ng-container>
              </span>
            </td>
            <td *ngIf="Appointment.isPayed != true;else IsNotPayed">{{'COMMON.NO' | translate}}</td>
            <ng-template #IsNotPayed><td>{{'COMMON.YES' | translate}}</td></ng-template>
            <td style="width: 200px;">
              <button *ngIf="Appointment.appoinmentStatus == null" style="margin: 0px 3px;" type="button" class="btn btn-primary btn-sm" (click)="OpenConfirmationModel(Appointment.appoinmentId,1)">{{ 'COMMON.CONFIRM' | translate }}</button>
              <button *ngIf="Appointment.appoinmentStatus == 'CONFIRMED' || Appointment.appoinmentStatus == null" style="margin: 0px 5px" type="button" class="btn btn-danger btn-sm" (click)="OpenConfirmationModel(Appointment.appoinmentId,0)">{{ 'COMMON.CANCEL' | translate }}</button>
              <!-- <button  *ngIf="Appointment.appoinmentStatus != 'CANCELED' && Appointment.isPayed != true"   type="button" class="btn btn-success btn-sm" (click)="Pay(Appointment.appoinmentDoctorId,Appointment.appoinmentId)" >{{ 'COMMON.PAY' | translate }}</button> -->

            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- end: Table -->
    <app-paginator class="d-flex justify-content-between align-items-center flex-wrap" [paginator]="paginator"
      (paginate)="paginate($event)"></app-paginator>
  </div>
</div>